var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.557 17.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 39 \\u2013 205"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2928"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2702"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M8.779 2.982a2.483 2.483 0 11-2.484 2.484 2.48 2.48 0 012.484-2.484zm0 11.755a5.961 5.961 0 01-4.967-2.666c.025-1.647 3.311-2.55 4.967-2.55s4.942.9 4.967 2.55a5.961 5.961 0 01-4.967 2.667z",
    "data-name": "Icon material-account-circle"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#444",
    d: "M8.778.5a8.278 8.278 0 108.278 8.278A8.281 8.281 0 008.778.5z",
    "data-name": "Icon material-account-circle"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleProfile);
export default __webpack_public_path__ + "static/media/circle-profile.4a2a6c60.svg";
export { ForwardRef as ReactComponent };